import { NotificacoesFacade } from './../../../shared/facades/notificacoes.facade';
import { Component, OnInit } from '@angular/core';
import { CorretorFacade } from 'src/app/shared/facades/corretor.facade';
import { ProdutoFacade } from 'src/app/shared/facades/produto.facade';
import { ICategoriaDeProduto } from 'src/app/shared/types/ICategoriaDeProduto';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ProdutoService } from 'src/app/shared/services/produto.service';
import { EAmbiente } from 'src/app/shared/types/EAmbienteGetBannerHome';
import { BannerPopupService } from 'src/app/shared/services/bannerPopup.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit {
  public isOpen: boolean = false
  public notificacoes$ = new Observable<number>();
  public rota: string = '../../../../assets/icons/sidebar'
  public produtos$ = new Observable<ICategoriaDeProduto[]>();
  public isRequestingProduto$ = new Observable<boolean>();

  constructor(
    private router: Router,
    public produtoFacade: ProdutoFacade,
    public corretorFacade: CorretorFacade,
    public notificacoesFacade: NotificacoesFacade,
    public produtoService: ProdutoService,
    public bannerPopupService: BannerPopupService,
  ) { }

  ngOnInit() {
    this.setStateValues();
    this.fetchData();
    this.showBannerDeAbertura();
  }

  setStateValues() {
    this.produtos$ = this.produtoFacade.getProdutos();
    this.isRequestingProduto$ = this.produtoFacade.isRequestingProdutos();
    this.notificacoes$ = this.notificacoesFacade.getNotificacoes();
  }

  fetchData() {
    this.corretorFacade.requestCorretorIfUnset();
    this.produtoFacade.requestProdutosIfUnset();
    this.notificacoesFacade.requestNotificacoesIfUnset();
  }

  getIcon(name: string) {
    return this.produtoFacade.getSidebarIcon(name);
  }

  logout() {
    this.corretorFacade.logout();
  }

  routeTo(route: string) {
    this.isOpen = false;
    this.router.navigate([route]);
  }

  openLink() {
    window.open('https://www.marlin.com.br/', '__blank');
  }

  selectMenu(id: number) {
    if (id != 7) // não incluir rede de descontos
      sessionStorage.setItem('selectedMenu', id.toString());
  }

  showBannerDeAbertura() {
    const ambiente = window.innerWidth > 800 ? EAmbiente.desktop : EAmbiente.mobile;
    this.corretorFacade.getCorretor().pipe(take(2)).subscribe(corretor => {
      if(!corretor)
        return;

      if(JSON.parse((sessionStorage.getItem('exibeModalImplanteI')))) {
        this.produtoService.getBannerHome(ambiente, corretor.produtor.uf).subscribe(
          res => {
            if(res) {
              this.bannerPopupService.open({
                image: res.urlImagem,
                onClick: () => {
                  if(res.redirecionarPlano) {
                    this.produtoFacade.redirecionarParaPaginaDeUmProduto(
                      parseInt(res.redirect.idProduto),
                      parseInt(res.redirect.idPlano) || undefined,
                      parseInt(res.redirect.idOperadora) || undefined
                    );
                    sessionStorage.setItem('exibeModalImplanteI', JSON.stringify(false))
                  }
                  this.bannerPopupService.close();
                },
                onClose: () => {
                  sessionStorage.setItem('exibeModalImplanteI', JSON.stringify(false))
                },
              });
            }
          },
        );
      }
    });
  }
}
